import InfoIcon from '@mui/icons-material/InfoOutlined';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Tooltip } from 'shared/components/Tooltip';

import { StopAdminViewButton } from './components/StopAdminViewButton';
import { Wrapper } from './components/Wrapper';

export const AdminViewFooter = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Typography variant="subtitle1" color="white">
        {t('adminView.title')}
      </Typography>
      <Tooltip title={t('adminView.tooltipContent')}>
        <InfoIcon sx={{ fontSize: 18, color: 'common.white' }} />
      </Tooltip>
      <StopAdminViewButton />
    </Wrapper>
  );
};
